import React, { useState } from 'react';

function SurveyStepTwentyFour({ formData, onNext }) {
    const [recommendationText, setRecommendationText] = useState(formData.recommendationText || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!recommendationText.trim()) {
            setError('Please share your thoughts before continuing.');
            return;
        }
        setError('');
        onNext({ recommendationText });
    };

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 5: Employee Experience</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                Would you recommend this company to others based on your experience? <span className="text-danger">*</span>
            </label>

            <textarea
                className="form-control"
                rows="6"
                value={recommendationText}
                onChange={(e) => setRecommendationText(e.target.value)}
                placeholder="Share your thoughts here..."
            />

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!recommendationText.trim()}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentyFour;
